import { Component, Input, HostListener, Inject } from '@angular/core'

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { ENTER, ESCAPE } from '@angular/cdk/keycodes'

@Component({
  selector: 'app-confirmation-dialog',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  @Input()
  title!: string

  @Input()
  text!: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {}

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if ([ENTER].includes(event.keyCode)) {
      this.dialogRef.close(true)
    }

    if ([ESCAPE].includes(event.keyCode)) {
      // On clos le débat !
      this.dialogRef.close(false)
    }
  }
}
